// extracted by mini-css-extract-plugin
export var columnItem = "_9l-3";
export var dragHandle = "_9l-0";
export var dragHandleHovered = "_9l-1";
export var dropdown = "_9l-4";
export var icon = "_9l-2";